import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="questionnaire-initiator"
export default class extends Controller {
  connect() {
    const elementId = this.element.dataset.elementId
    this.wait_for_assets(elementId, () => {
      window.initEmbodiaQuestionnaireForm(elementId)
    });
  }

  wait_for_assets(elementId, callback) {
    const check = () => {
      if (window.initEmbodiaQuestionnaireForm && document.getElementById(elementId)) {
        callback();
      } else {
        requestAnimationFrame(check); // try again on the next frame
      }
    };
    check();
  }
}
